module.exports = __webpack_public_path__ + "static/img/10一种用于弯管机的送料传动机构.dcaa1ac2.jpg";